module.exports = __webpack_public_path__ + "static/media/Instagram@3x.c1f6fb4b.png";